module.exports = __webpack_public_path__ + "img/xytl.b1b5d07a.jpg";